import { useCallback, useRef, useState } from 'react'

export const useNavigationMenuController = () => {
  const [isDrawerNavigationOpen, setIsNavigationDrawerOpen] = useState<boolean>(false)

  const [selectedNavigationItem, setSelectedNavigationItem] = useState<string>('')

  /**
   * Reference to the header navigation containers.
   * Used to position the navigation details component
   */
  const itemRefs = useRef<Record<string, HTMLButtonElement | null>>({})

  /**
   * Anchor element for the Current Navigation menu
   */
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const onNavigationSelection = useCallback((navigation: string) => {
    setSelectedNavigationItem(navigation)
    setAnchorEl(itemRefs.current[navigation] || null)
  }, [])

  const toggleNavigationDrawer = useCallback((currentState: boolean) => {
    setIsNavigationDrawerOpen(currentState)
  }, [])

  return {
    isDrawerNavigationOpen,
    toggleNavigationDrawer,
    onNavigationSelection,
    selectedNavigationItem,
    itemRefs,
    anchorEl,
    setAnchorEl,
  }
}
